import { memo } from 'react'
import { createPortal } from 'react-dom'

import { DragOverlay, defaultDropAnimationSideEffects } from '@dnd-kit/core'
import type { DropAnimation } from '@dnd-kit/core'

const dropAnimationConfig: DropAnimation = {
  sideEffects: defaultDropAnimationSideEffects({
    styles: {
      active: {
        opacity: '0.4',
      },
    },
  }),
}

type CrewSortableOverlayProps = {
  children?: React.ReactNode
}

export const CrewSortableOverlay: React.FC<CrewSortableOverlayProps> = memo(
  (props) =>
    // 祖先コンポーネントにfixedやoverflowが設定されている場合、オーバーレイの表示位置がずれる場合があるので、
    // ポータルを使用してbody直下に描画する
    // https://github.com/clauderic/dnd-kit/issues/1649#issuecomment-3455450773
    createPortal(
      <DragOverlay dropAnimation={dropAnimationConfig}>
        {props.children}
      </DragOverlay>,
      document.body
    )
)
